import { Component } from '@angular/core';
import { NewPaymentComponent } from '../new-payment/new-payment.component';
import { WifiQRCodeComponent } from '../wifi-qrcode/wifi-qrcode.component';
import { PaymentQRCodeComponent } from '../payment-qrcode/payment-qrcode.component';

@Component({
  selector: 'qwiko-all-services',
  imports: [NewPaymentComponent, WifiQRCodeComponent, PaymentQRCodeComponent],
  templateUrl: './all-services.component.html',
  styleUrl: './all-services.component.scss',
})
export class AllServicesComponent {}
